// src/layouts/components/dashboard/DashboardContinueSection.jsx

// Ara mateix això és la V1. Més endavant ja farem V2 i V3.
// El component no tanca la porta a V2. Per això el nom DashboardContinueSection està bé. 
// Internament ara pot llegir de catalogRecent, però més endavant podrà llegir de /api/dashboard/continue
// sense haver de canviar la idea del component.

// V1 — Recent item
// Local, simple, no backend.
// Good enough now.

// V2 — Real progress
// Backend-driven, based on projects/programs/sessions.
// Needed when certification and institutional programs are more mature.

// V3 — Next best action
// Dashboard as intelligent workspace orchestration.
// More strategic, but not needed now.

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import AVIcon from "../../../components/icons/AllVoicedIcons";
import { openCatalogLaunch } from "../../../catalog/utils/catalogLaunch";
import {
  clearRememberedCatalogEntry,
  getRememberedCatalogEntry
} from "../../../catalog/utils/catalogRecent";

import {
  formatLabel,
  getEntryShortDescription,
  getEntryTitle
} from "../../../catalog/utils/catalogDisplay";
import {
  ApplicationButton,
  ApplicationSectionHeader,
  ApplicationSurface
} from "../../../components/application";

export default function DashboardContinueSection() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [recentEntry, setRecentEntry] = useState(null);

  useEffect(() => {
    setRecentEntry(getRememberedCatalogEntry());
  }, []);

  if (!recentEntry) {
    return null;
  }

  const title = getEntryTitle(recentEntry, t);
  const description =
    getEntryShortDescription(recentEntry, t);

  const primaryLabel =
    formatLabel(recentEntry.primaryType) ||
    "Catalog entry";

  const handleContinue = () => {
    const launched = openCatalogLaunch(recentEntry, navigate);

    if (!launched && recentEntry.slug) {
      navigate(`/app/catalog/${recentEntry.slug}`);
    }
  };

  const handleViewDetails = () => {
    if (recentEntry.slug) {
      navigate(`/app/catalog/${recentEntry.slug}`);
    }
  };

  const handleDismiss = () => {
    clearRememberedCatalogEntry();
    setRecentEntry(null);
  };

  return (
    <ApplicationSurface
      ariaLabelledby="dashboard-continue-title"
      className="av-dashboard-continue"
      elevation="raised"
      variant="action"
    >
      <div className="av-dashboard-continue__layout">
        <div
          className="av-app-icon-badge av-dashboard-continue__icon"
          aria-hidden="true"
        >
          <AVIcon
            icon="repeat"
            size={24}
          />
        </div>

        <div className="av-dashboard-continue__content">
          <ApplicationSectionHeader
            contextLabel="Continue where you left off"
            title={title}
            titleId="dashboard-continue-title"
          />

          <p className="av-dashboard-continue__meta">
            {primaryLabel}
          </p>

          {description && (
            <p className="av-dashboard-continue__description">
              {description}
            </p>
          )}

          <div className="av-dashboard-actions">
            <ApplicationButton
              onClick={handleContinue}
            >
              Continue
            </ApplicationButton>

            {recentEntry.slug && (
              <ApplicationButton
                variant="secondary"
                onClick={handleViewDetails}
              >
                View details
              </ApplicationButton>
            )}

            <ApplicationButton
              variant="quiet"
              onClick={handleDismiss}
            >
              Dismiss
            </ApplicationButton>
          </div>
        </div>
      </div>
    </ApplicationSurface>
  );
}
